import { Money } from './entity';

export enum QUOTATION_STATUS {
  OPEN = 'open',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  CLOSED = 'closed',
  EXPIRED = 'expired',
  REFUSED = 'refused',
}

export interface Quotation {
  id: string;
  customerPortalStatus: CUSTOMER_PORTAL_STATUS;
  total: {
    taxExclusive: Money;
    taxInclusive: Money;
  };
  name: string;
  createdAt: string | null;
  updatedAt: string | null;
  expiry?: {
    expiresAfter: string | null;
    lockedAfterExpiry: boolean;
  };
  status: QUOTATION_STATUS;
}

export enum CUSTOMER_PORTAL_STATUS {
  NEW = 'new',
  UPDATED = 'updated',
  SIGNED = 'signed',
  VIEWED = 'viewed',
}
